/**
 * Created by jonas on 2020-03-18.
 */

import {
    GameIntroColors, GameIntroView,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {ImageIntroPage} from "./ImageIntroPage";
import {Layers} from "../view/TombstoneRipLayers";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TombstoneRip} from "../TombstoneRip";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class TombstoneRipIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xNudge : true,
        xSplit : true,
        xBet :true,
        xRip : true,
        volatility : Volatility.INSANE
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public async init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("entryBg", "resources/images/Entry_bg.jpg");
        imgLoader.add("entryBoard", "resources/images/Entry_board.png");
        imgLoader.add("entryButton", "resources/images/Entry_button.png");
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDivUp", "resources/images/Intro_Divider_up.png");
        imgLoader.add("introDivDown", "resources/images/Intro_Divider_down.png");
        imgLoader.add("feature1", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature1NoBoosted", "resources/images/Intro_Feature_1_NoBoosted.png");
        imgLoader.add("feature2", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature3", "resources/images/Intro_Feature_3.png");
        imgLoader.add("feature3_US", "resources/images/Intro_Feature_3_US.png");
        imgLoader.add("smoke", "resources/images/fullSmoke.png");
        imgLoader.add("xRipLogo", "resources/images/xRipLogo.png");

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add({
            family : "Vollkorn",
            weight : FontWeight.BLACK,
            style : FontStyle.NORMAL,
            url : "/resources/fonts/Vollkorn-Black.woff"
        });

        await Promise.all([imgLoader.load(), fontLoader.load()]);
        await this.initGraphics();
        return this;
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDivUp"));
        topSprite.anchor.set(0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDivDown"));
        bottomSprite.anchor.set(0.5, 0.6);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();

        this.pages = [
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature2"),
                    scale : 0.9,
                    position : new PIXI.Point(0, 10),
                    name:"xfeatures"
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature1"),
                    scale : 0.85,
                    position : new PIXI.Point(0, 5),
                    name:"boostedBetAllowed"
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature1NoBoosted"),
                    scale : 0.85,
                    position : new PIXI.Point(0, 5),
                    name:"boostedBetNotAllowed"
                }
            ]),
        ];
        this.showUSImage();

        TombstoneRip.apiPlugin.events.once(APIEvent.ALLOWED_GAME_FEATURES, (data: BetFeature[]) => {
            if (data.find((feature) => <unknown>feature as string === "BOOSTED_BET") !== undefined) {
                this.deleteBoostedBetPage("boostedBetNotAllowed");
            } else {
                this.deleteBoostedBetPage("boostedBetAllowed");
                this.stampConfig.xBet = false;
            }
        })
    }

    private deleteBoostedBetPage(deleteName:string):void{
        let id: number = -1;
        this.pages.forEach((item: SlideShowPage, index: number) => {
            if (item.name === deleteName) {
                id = index;
            }
        });
        this.pages.splice(id,1);
    }

    private showUSImage(): void {
        if (TombstoneRip.apiPlugin.gameClientConfiguration.isSet) {
            this.pages.push(new ImageIntroPage([
                {
                    texture: ImgLoader.getImgTexture(this.checkImageName()),
                    scale: 0.85,
                    position: new PIXI.Point(0, 5),
                    name:"boothillFreespins"
                }
            ]));

        } else {
            TombstoneRip.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.pages.push(new ImageIntroPage([
                    {
                        texture: ImgLoader.getImgTexture(this.checkImageName()),
                        scale: 0.85,
                        position: new PIXI.Point(0, 5),
                        name:"boothillFreespins"
                    }
                ]));
            });
        }
    }

    private checkImageName(): string {
        if (TombstoneRip.apiPlugin.gameClientConfiguration.showMultipliersInfo) {
            return "feature3";
        } else {
            return "feature3_US";
        }
    }

    public onClose():void {
        NolimitApplication.getLayerByName(Layers.FOREGROUND_TOP)!.interactiveChildren = true;
    }

    // public getCloseTimeline(introView:GameIntroView):TimelineLite {
    //     const tl = gsap.timeline();
    //     tl.add(gsap.to(introView, {alpha : 0, duration : 0.2}), 0.5);
    //     return tl;
    // }
}
